module.exports = __webpack_public_path__ + "static/media/12-MarioSuna(1).c7b08280.png";